require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./svgicon"));
	else if(typeof define === 'function' && define.amd)
		define(["./svgicon"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./svgicon")) : factory(root["./svgicon"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__13__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[21],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(241);


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _DragLayer = _interopRequireDefault(__webpack_require__(242));

exports["default"] = _DragLayer["default"];
exports.DragLayer = _DragLayer["default"];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _DragLayer = _interopRequireDefault(__webpack_require__(243));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var dragLayerClassName = _DragLayer["default"].dragLayerClassName.replace(/"/g, '');

var DragLayer = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(DragLayer, _Component);

  function DragLayer() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = DragLayer.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        currentOffset = _this$props.currentOffset,
        droppable = _this$props.droppable,
        children = _this$props.children;
    var x = currentOffset.x,
        y = currentOffset.y;
    var transform = "translate(" + x + "px, " + y + "px)";
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        transform: transform
      },
      className: "" + dragLayerClassName
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        visibility: droppable ? 'hidden' : 'visible'
      },
      className: dragLayerClassName + "__nodrop"
    }, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      size: "small",
      iconId: "common-nodrop",
      verticalAlign: "text-bottom"
    })), children);
  };

  return DragLayer;
}(_react.Component);

exports["default"] = DragLayer;
(0, _defineProperty2["default"])(DragLayer, "propTypes", {
  children: _propTypes["default"].node,
  currentOffset: _propTypes["default"].object.isRequired,
  droppable: _propTypes["default"].bool.isRequired
});

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(244);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-dragLayer{font-size:1rem;display:flex;align-items:center;vertical-align:middle;padding:0 16px;z-index:9999999;position:fixed;top:0px;margin-left:18px}.ba-common-dragLayer__nodrop{margin-left:-8px;margin-right:8px;position:relative}.bi--highContrast.ba-common-dragLayer{border:1px dotted transparent}.ba-common-dragLayer{background:#0f62fe;background:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);color:#fff;font-family:inherit}.ba-common-dragLayer__nodrop{color:#fff}\n", ""]);

// exports
exports.locals = {
	"dragLayerClassName": "\"ba-common-dragLayer\""
};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[240,0]]]);
});